export let INTERSECTION;

(function (INTERSECTION) {
  INTERSECTION[INTERSECTION["OUTSIDE"] = -1] = "OUTSIDE";
  INTERSECTION[INTERSECTION["INTERSECTING"] = 0] = "INTERSECTING";
  INTERSECTION[INTERSECTION["INSIDE"] = 1] = "INSIDE";
})(INTERSECTION || (INTERSECTION = {}));
//# sourceMappingURL=constants.js.map